import { EventListener } from './event.listener';
import { ObserverEvents } from './events';

export class EventManager {
  private listeners = new Map<string, EventListener[]>();

  subscribe(eventType: ObserverEvents, listener: EventListener): void {
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, []);
    }
    this.listeners.get(eventType)?.push(listener);
  }

  unsubscribe(eventType: ObserverEvents, listener: EventListener): void {
    if (this.listeners.has(eventType)) {
      const listeners = this.listeners.get(eventType);
      if (listeners) {
        const index = listeners.indexOf(listener);
        if (index > -1) {
          listeners.splice(index, 1);
        }
      }
    }
  }

  notify(eventType: ObserverEvents, data?: unknown): void {
    if (this.listeners.has(eventType)) {
      this.listeners.get(eventType)?.forEach((listener) => {
        listener.update(eventType, data);
      });
    }
  }
}
